import { SxProps, Theme } from '@mui/material';

export const selectSearchFormFieldStyles = (hasLabel: boolean) =>
  ({
    '& .MuiAutocomplete-root': {
      '&:focus-within': {
        zIndex: 100,
      },
      position: 'relative',
    },
    '& .MuiAutocomplete-root .MuiAutocomplete-inputRoot': {
      paddingBottom: 0,
      paddingTop: 0,
    },
    '& .MuiAutocomplete-root .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
      minWidth: 0,
    },
    height: hasLabel ? 56 : 40,
  }) satisfies SxProps<Theme>;
